import { Tc, PagingResultsViewModel, TTasaViewModel } from '../../../core/_infrastructure/types/common';

export class SolicitudItemResultsViewModel extends PagingResultsViewModel {
    public ResultList: SolicitudItemViewModel[];
}

export class SolicitudItemViewModel {
    public Id: number;
    public Codigo: string;
    public IdEstadoSolicitudDescripcion: string;
    public NifCif: string;
    public Importador: string;
    public Direccion: string;
    public NRegistro: string;
    public NombreTipoSolicitud: string;
    public CodigoTipoSolicitud: string;
    public IdEstadoSolicitud: number;
    public IsPredua: boolean;
}

export class SolicitudViewModel {
    constructor() {}

    public Id: number;
    public Codigo = '';
    public IdPuntoInspeccion = 0;
    public IdTipoSolicitud = 0;
    public IdSubTipoSolicitud: number | null = null;
    public IdEstadoSolicitud = 0;
    public EsExtranjero: boolean | null = false;
    public EsPrevia = false;
    public TTasaCollection: TTasaViewModel[];
    public TExportador: TExportadorViewModel = new TExportadorViewModel();
    public TImportador: TImportadorViewModel = new TImportadorViewModel();
    public TLugarMercancia: TLugarMercanciaViewModel = new TLugarMercanciaViewModel();
    public TMedioTransporte: TMedioTransporteViewModel = new TMedioTransporteViewModel();
    public TcTipoSolicitud: TcTipoSolicitudViewModel = new TcTipoSolicitudViewModel();
    public TwFinalizacionTraslado: TwFinalizacionTrasladoViewModel;
    public TcEstadoSolicitud: Tc;
    public TwTcSubTipoSolicitud: TcSubTipoSolicitudViewModel = new TcSubTipoSolicitudViewModel();
    public TwSolicitudJerarquia: TwSolicitudJerarquiaViewModel;
}

export class TExportadorViewModel {
    public IdSolicitud: number;
    public NombreExportador: string;
    public CiudadExportador: string;
    public IdPaisExportador: number;
    public DireccionExportador: string;
    public CodigoPostalExportador = '';
    //public IdMarm: number;
    //public TImportador: TImportadorViewModel = new TImportadorViewModel();
}

export class TImportadorViewModel {
    public Id: number;
    public Nif: string;
    public NRegistro: string;
    public Nombre: string;
    public Direccion: string;
    public Localidad = '';
    public CodigoPostalImportador = '';
    public IdPaisImportador: number | null;
    public RefTraces: string;
    public TipoRefTraces: string;
    public OperadorTraces: string;
    public TipoOperador: string;
}

export class TLugarMercanciaViewModel {
    public IdSolicitud: number;
    public IdPaisOrigen: number | null;
    public IdPaisDestino: number | null;
    public IdPaisProcedencia: number | null;
    public IdAduana: number | null = null;
    public IdUbicacion: number | null;
    public FechaInspeccion: Date | null;
    public IdIntervaloHoras: number | null = null;
}

export class TMedioTransporteViewModel {
    public IdSolicitud: number;
    public IdMedioTransporte: number | null;
    public NumeroOMI: string;
    public FechaLlegada: Date | null;
    public NumeroDeclaracionSumaria: string;
    public Mrn: string;
    public FechaRecuperacionMrn: Date | null;
    public IdPaisMedioTransporte: number | null;
    public TcTipoMedioTranporte: Tc;
}

export class TcTipoSolicitudViewModel {
    public Id: number;
    public Descripcion: string;
    public Codigo: string;
}

export class TcSubTipoSolicitudViewModel {
    public Id: number;
    public IdTipoSolicitud: number;
    public EsPreDua: boolean;
    public EsConCf: boolean | null;
}

export class TwSolicitudJerarquiaViewModel {
    public IdSolicitud: number;
    public IdSolicitudPadre: number;
    public IdTipoClonacion: number;
    public Guardada: boolean;
}

export class TwFinalizacionTrasladoViewModel {
    public IdSolicitud: number;
    public ChedPpTraslado: string;
    public Finalizado: boolean;
    public DeCexveg: boolean;
}
